<script>
	//NPM Modules
	import { createEventDispatcher } from 'svelte';
	import dayjs from 'dayjs';
	// Components
	import Datepicker from '@/Components/Datepicker.svelte';
	import Modal from '@/Components/Modal.svelte';
	import TextInput from '@/Components/NewTextInput.svelte';
	import LoadingButton from '@/Components/LoadingButton.svelte';
	import Switch from '@/Components/Switch.svelte';
	// Services
	import { notify } from '@/Services/Notify';
	// Stores
	import ACLStore from '@/Stores/ACLStore.js';

	export let competition;
	export let open;

	const dispatch = createEventDispatcher();

	let sending = false;

	let competitionForm = {
		name: competition.name,
		start_time: competition.start_time ?? undefined,
		fees: competition.fees,
		cashout_enabled: competition.cashout_enabled
	};

	let competitionDateToggle = !!competition.start_time;
	let competitionDate = dayjs(competition.start_time ?? undefined).format('YYYY-MM-DD');
	let competitionTime = dayjs(competition.start_time ?? undefined).format('HH:mm');

	$: competitionStart = dayjs(competitionDate + ' ' + competitionTime + ':00');
	$: competitionDateToggle && competitionStart && updateDateTimes();

	function updateDateTimes() {
		competitionForm.start_time = dayjs(competitionStart).format('YYYY-MM-DDTHH:mm:ssZ');
	}

	function updateCompetition() {
		sending = true;
		if (!competitionDateToggle) {
			delete competitionForm.start_time;
		}
		if (!$ACLStore && ACLStore.granted('competitions.update.fees')) {
			delete competitionForm.fees;
		}
		competition
			.patch(competitionForm)
			.then(() => {
				notify({
					type: 'success',
					title: 'Competition successfully updated',
					message: `${competition.name} successfully updated!`,
					timeout: 3
				});
				dispatch('updated');
				open = false;
			})
			.catch(() => {
				notify({
					type: 'danger',
					title: 'Error!',
					message: 'Problem updating competition',
					timeout: 3
				});
			})
			.finally(() => (sending = false));
	}
</script>

{#if open}
	<Modal on:close={() => (open = false)}>
		<h2 slot="header" class="pt-2 text-xl font-bold text-center">
			Update competition - {competition.name}
		</h2>
		<div class="flex flex-col w-full px-4 pt-2 text-center">
			<TextInput
				label="Competition Name"
				name="competitionName"
				className="py-4 w-full text-left"
				placeholder="Enter new competition name"
				bind:value={competitionForm.name}
			/>
			<div class="text-left mb-4" class:hidden={!competitionDateToggle}>
				<label class="form-label" for="competitionStartTime">Start Time: </label>
				<div class="flex flex-row">
					<div class="flex-shrink">
						<Datepicker
							selected={competitionDate}
							displayFormat="DD-MM-YYYY"
							dateChosen={(date) => {
								competitionDate = dayjs(date).format('YYYY-MM-DD');
							}}
							disabled={!competitionDateToggle}
						/>
					</div>
					<TextInput
						bind:value={competitionTime}
						disabled={!competitionDateToggle}
						name="competitionStartTime"
						className={!competitionDateToggle ? 'opacity-50' : ''}
						type="time"
					/>
				</div>
			</div>
			{#if $ACLStore && ACLStore.granted('competitions.update.fees')}
				<TextInput
					label="Competition Fees"
					name="competitionFees"
					suffix="%"
					type="number"
					step="0.01"
					className="pb-4 w-full text-left"
					placeholder="Enter new competition fees"
					bind:value={competitionForm.fees}
				/>
			{/if}
			<div class="flex flex-row mb-2">
				<label class="form-label" for="competitionCashoutEnabled"
					>Cashout enabled:
					<Switch name="competitionCashoutEnabled" bind:checked={competitionForm.cashout_enabled} className="ml-1" />
				</label>
			</div>
			<LoadingButton on:click={() => updateCompetition()} loading={sending} className="mb-4 btn btn-primary">
				{sending ? 'Updating' : 'Update'}
			</LoadingButton>
			<button class="mb-4 btn btn-muted" on:click={() => (open = false)}>Cancel</button>
		</div>
	</Modal>
{/if}
